import "../Main.scss";
import { MdHomeFilled, MdKeyboardArrowRight } from "react-icons/md";
import { MdClose } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./my.scss";
import "../../lib/form/form.scss";
import axios from "axios";
import jwtDecode from "jwt-decode";
import PwdModal from "../../components/PwdModal";
import ConfirmModal from "../../components/ConfirmModal";
import Post from "../../utils/postUtil";
import CompanyNum from "../../components/CompanyNum";
import CompanyUploadModal from "../../components/CompanyUploadModal";
import Swal from "sweetalert2";
// import "../lib/modal/modal.scss";
function My() {
  let navigate = useNavigate();

  // 토큰, decode id
  const token = window.sessionStorage.getItem("token");
  const id = jwtDecode(token).sub;

  // 마이페이지 상세정보
  const [myinfo, setMyInfo] = useState("");
  const [userid, setUserid] = useState("");
  const [companyRegNum, setCompanyRegNum] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [ceoName, setCeoName] = useState("");
  const [telNum, setTelNum] = useState("");
  const [faxNum, setFaxNum] = useState("");
  const [emailForTax, setEmailForTax] = useState("");
  const [postNum, setPostNum] = useState("");
  const [address, setAddress] = useState("");
  const [detailAddress, setDetailAddress] = useState("");
  const [docId, setDocId] = useState(""); // 사업자 등록증 ID

  // 모달
  const [pwdShowModal, setPwdShowModal] = useState(false);
  const [modifyShowModal, setModifyShowModal] = useState(false);
  const [doneShowModal, setDoneModal] = useState(false);
  const [postShowModal, setPostShowModal] = useState(false);
  const [withdrawalShowModal, setWithdrawalShowModal] = useState(false);
  const [companyUploadShowModal, setCompanyUploadShowModal] = useState(false);
  const [failedShowModal, setFailedShowModal] = useState(false);

  // 우편번호 검색
  const [enroll_company, setEnroll_company] = useState({
    zonecode: "",
    address: "",
  });
  const handleInput = (e) => {
    setEnroll_company({
      ...enroll_company,
      [e.target.name]: e.target.value,
    });

    setPostNum(enroll_company.zonecode);
    setAddress(enroll_company.address);
  };

  // 실무자 정보
  const [staffEmail1, setStaffEmail1] = useState("");
  const [staffEmail2, setStaffEmail2] = useState("");
  const [staffName1, setStaffName1] = useState("");
  const [staffName2, setStaffName2] = useState("");
  const [staffPosition1, setStaffPosition1] = useState("");
  const [staffPosition2, setStaffPosition2] = useState("");
  const [staffTelNum1, setStaffTelNum1] = useState("");
  const [staffTelNum2, setStaffTelNum2] = useState("");

  // 마이페이지 수정
  const [inputDisable, setInputDisable] = useState(true);
  const [buttonType, setButtonType] = useState("Modify");

  // 비밀번호 변경
  const [oldWords, setOldWords] = useState("");
  const [newWords, setNewWords] = useState("");
  const [checkNewWords, setCheckNewWords] = useState("");
  const [pwdErrorMsg, setPwdErrorMsg] = useState(false);

  // 비밀번호 변경 함수
  const changePwd = async () => {
    // if (checkNewWords !== newWords) {
    //   alert("비밀번호가 일치하지 않습니다.");
    // }
    if (checkNewWords === newWords) {
      const params = new URLSearchParams();
      params.append("oldWords", oldWords);
      params.append("newWords", newWords);
      try {
        const response = await axios.patch(
          `/api/applicant/${id}/change-password`,
          params,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        setPwdShowModal(false);
        navigate("/");

        Swal.fire("성공", "비밀번호 변경 완료", "success");
      } catch (error) {
        console.log(error);
        if (error.response.status === 401) {
          setPwdErrorMsg(true);
        }
        console.log(error);
      }
    }
  };
  const onChangeHandler = (e) => {
    if (e.target.name === "oldWords") {
      setOldWords(e.target.value);
    }
    if (e.target.name === "newWords") {
      setNewWords(e.target.value);
    }
    if (e.target.name === "checkNewWords") {
      setCheckNewWords(e.target.value);
    }
  };

  // 회원탈퇴
  const quitMemeber = async () => {
    try {
      const response = await axios.delete(`/api/applicant/${id}`);
      window.sessionStorage.removeItem("token");
      navigate("/");
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  // 마이페이지 수정
  const onClickModify = async () => {
    setInputDisable(false);
    setButtonType("Save");
  };

  // 마이페이지 저장
  const onClickSave = async () => {
    if (buttonType !== "Modify") {
      await axios
        .patch(
          `/api/applicant/${id}`,
          {
            id: userid,
            companyRegNum: companyRegNum,
            companyName: companyName,
            ceoName: ceoName,
            telNum: telNum,
            faxNum: faxNum,
            emailForTax: emailForTax,
            postNum: postNum,
            address1: address,
            address2: detailAddress,
            staffName1: staffName1,
            staffPosition1: staffPosition1,
            staffEmail1: staffEmail1,
            staffTelNum1: staffTelNum1,
            staffName2: staffName2,
            staffPosition2: staffPosition2,
            staffEmail2: staffEmail2,
            staffTelNum2: staffTelNum2,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          doneModal();
        })
        .catch((error) => {
          console.log(error);
        });
      setInputDisable(true);
      setButtonType("Modify");
    }
  };
  const onChangeCompanyName = ({ target: { value } }) => {
    if (myinfo.state !== 11) {
      setCompanyName(value);
    }
  };
  const onChangeCeoName = ({ target: { value } }) => {
    setCeoName(value);
  };
  const onChangeTelNum = ({ target: { value } }) => {
    setTelNum(value);
  };
  const onChangeFaxNum = ({ target: { value } }) => {
    setFaxNum(value);
  };
  const onChangeEmailForFax = ({ target: { value } }) => {
    setEmailForTax(value);
  };
  const onChangePostNum = ({ target: { value } }) => {
    setPostNum(value);
  };
  const onChangeAddress = ({ target: { value } }) => {
    setAddress(value);
  };
  const onChangeDetailAddress = ({ target: { value } }) => {
    setDetailAddress(value);
  };
  const onChangeStaffName1 = ({ target: { value } }) => {
    setStaffName1(value);
  };
  const onChangeStaffPosition1 = ({ target: { value } }) => {
    setStaffPosition1(value);
  };
  const onChangeStaffEmail1 = ({ target: { value } }) => {
    setStaffEmail1(value);
  };
  const onChangeStaffTelNum1 = ({ target: { value } }) => {
    setStaffTelNum1(value);
  };
  const onChangeStaffName2 = ({ target: { value } }) => {
    setStaffName2(value);
  };
  const onChangeStaffPosition2 = ({ target: { value } }) => {
    setStaffPosition2(value);
  };
  const onChangeStaffEmail2 = ({ target: { value } }) => {
    setStaffEmail2(value);
  };
  const onChangeStaffTelNum2 = ({ target: { value } }) => {
    setStaffTelNum2(value);
  };

  // 모달 함수
  const openModal = () => {
    setPwdShowModal(true);
  };
  const closeModal = () => {
    setPwdShowModal(false);
  };
  const modifyModal = () => {
    setModifyShowModal(true);
  };
  const closeModifyModal = () => {
    setModifyShowModal(false);
  };
  const doneModal = () => {
    setDoneModal(true);
  };
  const closeDoneModal = () => {
    setDoneModal(false);
  };
  const handleComplete = () => {
    setPostShowModal(!postShowModal);
  };
  const withdrawalModal = () => {
    setWithdrawalShowModal(true);
  };
  const closeWithdrawalModal = () => {
    setWithdrawalShowModal(false);
  };
  const companyUploadModal = () => {
    setCompanyUploadShowModal(true);
  };
  const closeCompanyUploadModal = () => {
    setCompanyUploadShowModal(false);
  };

  useEffect(() => {
    axios
      .get(`/api/applicant/${id}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        // 마이페이지 상세정보
        setMyInfo(response.data);
        setUserid(response.data.id);
        setCompanyRegNum(response.data.companyRegNum);
        setCompanyName(response.data.companyName);
        setCeoName(response.data.ceoName);
        setTelNum(response.data.telNum);
        setEmailForTax(response.data.emailForTax);
        setFaxNum(response.data.faxNum);
        setPostNum(response.data.postNum);
        setAddress(response.data.address1);
        setDetailAddress(response.data.address2);
        setDocId(response.data.doc?.id);

        // 실무자 정보
        setStaffEmail1(response.data.staffEmail1);
        setStaffEmail2(response.data.staffEmail2);
        setStaffName1(response.data.staffName1);
        setStaffName2(response.data.staffName2);
        setStaffPosition1(response.data.staffPosition1);
        setStaffPosition2(response.data.staffPosition2);
        setStaffTelNum1(response.data.staffTelNum1);
        setStaffTelNum2(response.data.staffTelNum2);
      })
      .catch((error) => {
        console.log(error);
        console.log(error);
      });
  }, []);

  return (
    <>
      {companyUploadShowModal ? (
        <CompanyUploadModal
          closeModal={closeCompanyUploadModal}
          content1={"파일선택"}
          content2={"사업자등록증 다운로드"}
          modalTitle={"사업자 등록증"}
          userId={userid}
        />
      ) : null}
      {withdrawalShowModal ? (
        <div className="popup_bg_bbs " onClick={withdrawalModal}>
          <div
            className="password_change "
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pophead_bbs">
              <h1>회원탈퇴</h1>
            </div>
            <div className="password_change_inner">
              진행하시겠습니까?
              <div className="btns_wrap">
                <button className="btn_color" onClick={closeWithdrawalModal}>
                  <span className="material-icons">취소</span>
                </button>
                <button onClick={quitMemeber} className="btn_color">
                  <span className="material-icons">탈퇴</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {postShowModal ? (
        <div className="popup_bg_bbs" onClick={handleComplete}>
          <div className="popup_bbs">
            {/* <span className='close_btn' onClick={closeModal}><MdClose /></span> */}
            {
              <Post
                company={enroll_company}
                setcompany={setEnroll_company}
                showmodal={setPostShowModal}
                setPostNum={setPostNum}
                setAddress1={setAddress}
              ></Post>
            }
          </div>
        </div>
      ) : null}
      {pwdShowModal ? (
        <PwdModal
          closeModal={closeModal}
          onChangeHandler={onChangeHandler}
          changePwd={changePwd}
          pwdErrorMsg={pwdErrorMsg}
        />
      ) : null}
      {modifyShowModal ? (
        <ConfirmModal
          closeModal={closeModifyModal}
          modalTitle={"수정 가능"}
          content={"정보 수정이 가능합니다."}
        />
      ) : null}
      {doneShowModal ? (
        <ConfirmModal
          closeModal={closeDoneModal}
          modalTitle={"저장 완료"}
          content={"정보 저장이 완료되었습니다."}
        />
      ) : null}

      <div className=" location_wrap">
        <div className="location">
          <Link to="/">
            <MdHomeFilled />
          </Link>
          <MdKeyboardArrowRight />
          <Link to="/My">마이페이지</Link>
        </div>
      </div>

      <div className="contain my_wrap">
        <form className="my_page" action="" method="">
          <div className="my_page_heading">
            <div className="my_page_heading_inner">
              <Link className="active_tab" to="/my">
                마이페이지
              </Link>
              <Link to="/breakdown/cits">나의 신청내역</Link>
              <Link to="/succession">지위승계</Link>
            </div>
            <p className="modify_none">
              <span>■</span> 수정불가
            </p>
          </div>
          <div className="row">
            <div className="col">
              <div className="input_row">
                <div className="input_col">
                  <label htmlFor="id">아이디</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: "#eee",
                      }}
                      id="id"
                      className="input_line"
                      type="text"
                      placeholder="아이디"
                      defaultValue={userid}
                      disabled
                    />
                    {inputDisable ? (
                      <button
                        className="btn_none"
                        onClick={(e) => {
                          e.preventDefault();
                          openModal();
                        }}
                        disabled={inputDisable}
                      >
                        비밀번호변경
                      </button>
                    ) : (
                      <button
                        className="btn_color"
                        onClick={(e) => {
                          e.preventDefault();
                          openModal();
                        }}
                        disabled={inputDisable}
                      >
                        비밀번호변경
                      </button>
                    )}
                  </div>
                </div>
                <div className="input_col">
                  <label htmlFor="bus_num">사업자등록증</label>
                  <div className="input_wrap">
                    {inputDisable ? (
                      <button
                        className="btn_none"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          companyUploadModal();
                        }}
                        disabled={inputDisable}
                      >
                        사업자 등록증
                      </button>
                    ) : (
                      <button
                        className="btn_color"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          companyUploadModal();
                        }}
                        disabled={inputDisable}
                      >
                        사업자 등록증
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="input_row">
                <div className="input_col">
                  <label htmlFor="bus_num">사업자등록번호</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: "#eee",
                      }}
                      id="bus_num"
                      className="input_line"
                      type="text"
                      placeholder="사업자등록번호"
                      defaultValue={companyRegNum}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="input_col">
                  <label htmlFor="co_name">회사명</label>
                  <div className="input_wrap">
                    {myinfo.state === 11 ? (
                      <input
                        style={{
                          backgroundColor: myinfo.state === 11 ? "#eee" : "",
                        }}
                        id="co_name"
                        className="input_line"
                        type="text"
                        defaultValue={companyName}
                        placeholder="회사명"
                        disabled={true}
                        onChange={onChangeCompanyName}
                      />
                    ) : (
                      <input
                        style={{
                          backgroundColor: inputDisable ? "#eee" : "",
                        }}
                        id="co_name"
                        className="input_line"
                        type="text"
                        defaultValue={companyName}
                        placeholder="회사명"
                        disabled={inputDisable}
                      />
                    )}
                  </div>
                </div>
                <div className="input_col">
                  <label htmlFor="ceo">대표자명</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: "#eee",
                      }}
                      id="ceo"
                      className="input_line"
                      type="text"
                      placeholder="대표자명"
                      defaultValue={ceoName}
                      disabled={true}
                      onChange={onChangeCeoName}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="input_row">
                <div className="input_col"></div>
              </div>
              <div className="input_row">
                <div className="input_col">
                  <label htmlFor="bus_num">연락처</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="bus_num"
                      className="input_line"
                      type="tel"
                      placeholder="-없이"
                      defaultValue={telNum}
                      disabled={inputDisable}
                      onChange={onChangeTelNum}
                    />
                  </div>
                </div>
                <div className="input_col">
                  <label htmlFor="co_fax">팩스</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="co_fax"
                      className="input_line"
                      type="text"
                      placeholder="팩스 번호"
                      defaultValue={faxNum}
                      disabled={inputDisable}
                      onChange={onChangeFaxNum}
                      required
                    />
                  </div>
                </div>
                <div className="input_col">
                  <label htmlFor="co_fax">전자계산서 수신자 이메일</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="co_fax"
                      className="input_line"
                      type="text"
                      placeholder="전자계산서 수신자 이메일"
                      defaultValue={emailForTax}
                      disabled={inputDisable}
                      onChange={onChangeEmailForFax}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="input_row">
                <div className="input_col">
                  <label htmlFor="id">우편번호</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="post_num_id"
                      className="input_line"
                      type="text"
                      placeholder="우편번호"
                      defaultValue={postNum}
                      disabled={inputDisable}
                      onClick={(e) => {
                        e.preventDefault();
                        handleComplete();
                      }}
                      onChange={handleInput}
                      readOnly
                    />
                    {inputDisable ? (
                      <button
                        className="btn_none"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          handleComplete();
                        }}
                        disabled={inputDisable}
                      >
                        주소검색
                      </button>
                    ) : (
                      <button
                        className="btn_color"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          handleComplete();
                        }}
                        disabled={inputDisable}
                      >
                        주소검색
                      </button>
                    )}
                  </div>
                </div>
                <div className="input_col"></div>
              </div>
              <div className="input_row">
                <div className="input_col">
                  <label htmlFor="bus_num">주소</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="bus_num"
                      className="input_line"
                      type="text"
                      placeholder="도로명주소"
                      defaultValue={address}
                      disabled={inputDisable}
                      onChange={onChangeAddress}
                      onClick={(e) => {
                        e.preventDefault();
                        handleComplete();
                      }}
                      readOnly
                    />
                    {/* <button className="btn_color">버튼</button> */}
                  </div>
                </div>
                <div className="input_col">
                  <label htmlFor="co_name">상세주소</label>
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="co_name"
                      className="input_line"
                      type="text"
                      placeholder="상세주소"
                      defaultValue={detailAddress}
                      disabled={inputDisable}
                      onChange={onChangeDetailAddress}
                    />
                    {/* <button className="btn_color">버튼</button> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <span style={{ fontSize: "13px" }}>실무자1</span>
              <div className="input_row">
                <div className="input_col">
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="bus_num"
                      className="input_line"
                      type="text"
                      placeholder="실무자이름"
                      defaultValue={myinfo.staffName1}
                      disabled={inputDisable}
                      onChange={onChangeStaffName1}
                    />
                  </div>
                </div>
                <div className="input_col">
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="co_name"
                      className="input_line"
                      type="text"
                      placeholder="직책"
                      disabled={inputDisable}
                      defaultValue={myinfo.staffPosition1}
                      onChange={onChangeStaffPosition1}
                    />
                  </div>
                </div>
                <div className="input_col">
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="co_name"
                      className="input_line"
                      type="email"
                      placeholder="이메일"
                      defaultValue={myinfo.staffEmail1}
                      disabled={inputDisable}
                      onChange={onChangeStaffEmail1}
                      required
                    />
                  </div>
                </div>
                <div className="input_col">
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="co_name"
                      className="input_line"
                      type="text"
                      placeholder="실무자 연락처"
                      defaultValue={myinfo.staffTelNum1}
                      disabled={inputDisable}
                      onChange={onChangeStaffTelNum1}
                    />
                  </div>
                </div>
              </div>
              <span style={{ fontSize: "13px" }}>실무자2</span>

              <div className="input_row">
                <div className="input_col">
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="bus_num"
                      className="input_line"
                      type="text"
                      placeholder="실무자이름"
                      defaultValue={myinfo.staffName2}
                      disabled={inputDisable}
                      onChange={onChangeStaffName2}
                    />
                  </div>
                </div>
                <div className="input_col">
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="co_name"
                      className="input_line"
                      type="text"
                      placeholder="직책"
                      defaultValue={myinfo.staffPosition2}
                      disabled={inputDisable}
                      onChange={onChangeStaffPosition2}
                    />
                  </div>
                </div>
                <div className="input_col">
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="co_name"
                      className="input_line"
                      type="text"
                      placeholder="이메일"
                      defaultValue={myinfo.staffEmail2}
                      disabled={inputDisable}
                      onChange={onChangeStaffEmail2}
                      required
                    />
                  </div>
                </div>
                <div className="input_col">
                  <div className="input_wrap">
                    <input
                      style={{
                        backgroundColor: inputDisable ? "#eee" : "",
                      }}
                      id="co_name"
                      className="input_line"
                      type="text"
                      placeholder="실무자 연락처"
                      defaultValue={myinfo.staffTelNum2}
                      disabled={inputDisable}
                      onChange={onChangeStaffTelNum2}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="input_wrap submit_btn">
              <button
                type="button"
                className="btn_none"
                onClick={withdrawalModal}
              >
                탈퇴
              </button>
              {buttonType === "Modify" ? (
                <>
                  <button
                    type="button"
                    className="btn_color"
                    onClick={(e) => {
                      e.preventDefault();
                      onClickModify();
                      modifyModal();
                    }}
                  >
                    수정
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  className="btn_color"
                  onClick={(e) => {
                    e.preventDefault();
                    onClickSave();
                    doneModal();
                  }}
                >
                  저장
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default My;
